import DefaultListItem from '@/components/AssetsList/ListItem'
import PointsDisplay from '../ArcadeLeaderboard/PointsDisplay'
import { GroupedAsset } from '@/util/assetHelpers'

const ListItem = ({ item }: { item: GroupedAsset }) => {
  return (
    <DefaultListItem
      item={item}
      rightColumnChildren={
        <PointsDisplay
          iconClassName="text-white"
          className="text-arcadeGreen"
          value={item.points}
        />
      }
    />
  )
}

export default ListItem
